import React from 'react';
import { SecondaryButton } from '@magoosh/lib/button';
import { Modal } from 'react-bootstrap';
import style from './style.module.scss';
import { useTopicOverviewContext } from '../../pages/topic_overview/context';

export const TopicPerformanceExplanationModal: React.FC = () => {
  const { openPerformanceExplanationModal, togglePerformanceExplanationModal } = useTopicOverviewContext();

  return (
    <Modal show={openPerformanceExplanationModal} onHide={() => togglePerformanceExplanationModal()}>
      <Modal.Header className={style.header} closeButton>
        <h3>Your Current Level and Score Improvement Opportunity Explained</h3>
      </Modal.Header>
      <Modal.Body className={style.body}>
        <p>
          <strong>Your Current Level</strong>
        </p>
        <p>
          Based on the difficulty and type of questions you answer, Magoosh will estimate your level on a
          scale of 0-10.
          <br />
          0-1 = Too early to tell <br />
          2-4 = Beginner
          <br />
          5-7 = Intermediate
          <br />
          8-10 = Advanced
          <br />
        </p>

        <p>
          <strong>Score Improvement Opportunity</strong>
        </p>

        <p>Not every topic offers you the same opportunity for score improvement.</p>
        <p>
          For example, if you're already very strong in a topic, studying it more won't help you improve your
          overall score.
        </p>
        <p>
          On the other hand, if you’re performaing at a beginner level in a high significance topic, studying
          beginner material offers you a greater opportunity for score improvement than studying more advanced
          material.
        </p>
        <p>
          Magoosh looks at your performance across all topics in Math and Verbal and assigns them a
          personalized score improvement opportunity so you can be confident you’re focusing on the topics
          that give you the highest potential to improve your score.
        </p>

        <SecondaryButton
          onClick={() => {
            togglePerformanceExplanationModal();
          }}
          block={true}
          className="u-margin-T-m">
          Close
        </SecondaryButton>
      </Modal.Body>
    </Modal>
  );
};

export default TopicPerformanceExplanationModal;
